import { localStore } from '@utils'
interface IVistorInfo {
  name: string;
  isSave: 0 | 1;
  avatar?: string;
  id?: string;
}

export function genID () {
  return `${new Date().getTime()}${Math.random().toString().substring(2, 8)}`
}

/** 保存用户信息 */
export function setVisitorInfo (data: IVistorInfo) {
  const key = `ls.visitor.${Config.BRANDID}`
  if (!data.id) {
    data.id = genID()
  }
  localStore.set(key, data, data.isSave === 1 ? 0 : 1000 * 60 * 60 * 24)
}

/** 获取用户信息 */
export function getVisitorInfo (): IVistorInfo | null {
  const key = `ls.visitor.${Config.BRANDID}`
  const info = localStore.get(key)
  try {
    return info || null
  } catch {
    return null
  }
}
/** 清除访客信息 */
export function clearVisitorInfo () {
  const key = `ls.visitor.${Config.BRANDID}`
  const info = localStore.get(key)
  if (info && info.isSave === 0) {
    localStore.remove(key)
  }
}
